




























import { Component, Vue } from 'vue-property-decorator';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import PerformanceItem from '@/components/molecules/PerformanceItem/PerformanceItem.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import BaseChart from '@/componentsV2/molecules/Chart/BaseChart.vue';

import PerformanceUtils from '@/utils/PerformanceUtils';
import { IChartSerie } from '@/models/performance';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DropDownLocations from '@/componentsV2/molecules/DropDownLocations/DropDownLocations.vue';
import PerformanceConversionsService from '@/api/PerformanceConversionsService';
import { IPeriod } from '@/models/period';
import { EBusinessReportType } from '@/models/business';
import { CustomSelectOption } from '@/components/CustomSelect/CustomSelectModel';

@Component({
  components: {
    SectionWrapper,
    SectionData,
    PerformanceItem,
    CustomSelect,
    BaseChart,
    Typography,
    DropDownLocations
  }
})
export default class PerformanceRedemptionOverview extends Vue {
  performanceConversionsService = new PerformanceConversionsService();

  series: IChartSerie[] = [];
  loading = false;
  options = PerformanceUtils.chartOptions({
    colors: [
      this.businessInfo.reportType === EBusinessReportType.OFFER
        ? '#D300F5'
        : '#00BABA',
      '#D300F5'
    ]
  });

  period: IPeriod = PerformanceUtils.defaultPeriod();
  locationsActive: any[] = [];

  get queryParameters() {
    const params: any = { from: this.period.start, to: this.period.end };

    if (this.businessInfo.reportType !== EBusinessReportType.OFFER_COINS) {
      params.redemptionTypes = this.businessInfo.reportType;
    }

    return params;
  }

  get tPrefix() {
    return `performance.redemptions.overtime`;
  }

  get configSection() {
    return {
      descriptionMaxWidth: '684px',
      titleFontSize: '18px',
      padding: this.$mobileCheck() ? '24px' : '32px 24px',
      datepickerPosition: !this.businessInfo.businessLocations
        ? 'rightOfTheSearch'
        : 'rightOfTheTitle'
    };
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  handlePeriodChange(period: IPeriod) {
    this.period = PerformanceUtils.normalizedPeriod(period);
    this.loadGraph();
  }

  changedLocations(items: CustomSelectOption[]) {
    this.locationsActive = items.map(item => ({ ...item, id: item.uuid }));
    this.loadGraph();
  }

  async loadGraph() {
    try {
      this.$showLoader();

      let locations = [];

      if (
        this.businessInfo.businessLocations.length !==
        this.locationsActive.length
      ) {
        locations = this.locationsActive;
      }

      const response = await this.performanceConversionsService.getGraph(
        this.queryParameters,
        locations
      );

      if (response.status !== 200) return;
      this.series = PerformanceUtils.normalizedChartSeries(response.data);
    } finally {
      this.$hideLoader();
    }
  }

  created() {
    this.loadGraph();
  }
}
